import React, {useEffect, useState} from "react";
import {useAppContext, useAppInfo, useQuery} from "../../../helpers/hooks/common-hook";
import {getAuthConfig} from "../../../services/auth";
import Loader from "../../../components/loader";
import {
    APP_ID_KEY, AUTH_REQUEST_STATE_KEY, AUTH_CONFIG_KEY,
    AUTH_CONNECTOR_KEY,
    CHANNEL_KEY,
    SESSION_ID_KEY
} from "../../../consts/common-consts";


const ChildNode = React.memo((props) => {
    return React.Children.map(props.children, (child) => {
        const childProps = {
            authConfig: props.authConfig
        };

        if (React.isValidElement(child)) {
            return React.cloneElement(child, childProps);
        }

        return child;
    });
});

export default function AuthConfig(props) {
    const { userCache, authConnector, sessionId, channel } = props

    let appId;
    let accessKey;
    const userInfo = useAppInfo();
    if (userInfo) {
        appId = userInfo.appId;
        accessKey = userInfo.accessKey;
    } else {
        const savedSession = JSON.parse(sessionStorage.getItem(AUTH_REQUEST_STATE_KEY))
        appId = savedSession.appId
        accessKey = savedSession.accessKey
    }

    const [authConfig, setAuthConfig] = useState();

    const [apiCallState, setApiCallState] = useState({
        processing: false,
        completed: false,
        success: false,
        failed: false,
        errorMessage: ''
    });

    const updateApiCallState = (processing, completed, success, failed, errorMessage) => {
        setApiCallState(Object.assign({}, { processing, completed, success, failed, errorMessage }))
    }

    async function fetchAuthConfig() {
        updateApiCallState(true);
        const config = await getAuthConfig(appId, authConnector, accessKey)
        if (config) {
            setAuthConfig(config);
            sessionStorage.setItem(AUTH_REQUEST_STATE_KEY, JSON.stringify({
                appId,
                authConnector,
                sessionId,
                channel,
                accessKey
            }));
            sessionStorage.setItem(AUTH_CONFIG_KEY, JSON.stringify(config));
            updateApiCallState(false, true, true);
        } else {
            updateApiCallState(false, true, false, true, "Unable to load auth config");
        }
    }

    async function fetchAuthConfigFromCache() {
        setAuthConfig(JSON.parse(sessionStorage.getItem(AUTH_CONFIG_KEY)));
    }

    useEffect(() => {
        if (userCache) {
            fetchAuthConfigFromCache()
        } else {
            fetchAuthConfig();
        }
    }, []);

    return (
        <div className="px-2">
            {(authConfig) &&
                <ChildNode authConfig={authConfig}>{props.children}</ChildNode>
            }

            {(apiCallState.completed && apiCallState.failed) &&
                <div>
                    <span className="flex flex-row text-sm text-red-500">{apiCallState.errorMessage}</span>
                </div>
            }

            {apiCallState.processing &&
                <div className="flex flex-row justify-center items-center pl-4 py-4">
                    <Loader/>
                </div>
            }
        </div>

    )
};